import { useContext, useEffect, useState } from 'react';

// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Radio, RadioGroup } from 'rsuite';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';

import { Dialog } from '@mui/material';

import { SelectRegion } from './selectRegion';
import { ContextApi } from '../../context/contextApi';

import styles from './style.module.scss';

export function FormEditUser({
  handleCloseEditUser,
  showEditUser,
}) {
  const {
    getUserThisId,
    userThisId,
    listAllRegional,
    allRegional,
    upDateUserRegional
} = useContext(ContextApi);
    const [nameUser, setNameUser] = useState('');
    const [email, setEmail] = useState('');
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    const [valueProfile, setValueProfile] = useState('');
    const [loading, setLoading] = useState(false);
    const [idUser, setIdUser] = useState('');

    function handleSubmitEditUser() {
      upDateUserRegional(idUser,
        {
        name: nameUser,
        role: valueProfile,
        email: email,
        regional_id: right.map(regional => regional?.id)
      });
      handleCloseEditUser();
    }
    
    useEffect(() => {
      if(showEditUser?.idUser !== '') {
        setLoading(true);
        getUserThisId(showEditUser?.idUser);
        listAllRegional();
      }
    }, [showEditUser?.idUser])

    useEffect(() => {
      let reginalMap = []
      let regionalReturn = []
      setTimeout(() => {
        setNameUser(userThisId?.name);
        setEmail(userThisId?.email);
        setValueProfile(userThisId?.role);
        setIdUser(userThisId?.id);
        allRegional.map(regional => {
          reginalMap.push({
            id: regional.id,
            uf: regional.nome
          })
        });
        userThisId?.regionais.map(regs => {
          regionalReturn.push({
            id: regs.id,
            uf: regs.nome
          })
        });
        setLeft(reginalMap);
        setRight(regionalReturn);
        setLoading(false);
      }, 2500);
    }, [userThisId])

    return (
      <Dialog
        onClose={handleCloseEditUser} 
        open={showEditUser.show}
        className={styles.containerEditUser}
      >
        <div className={styles.boxFormNewUserVidroEditUser}>
          <CloseIcon 
          onClick={() => handleCloseEditUser()}
          className={styles.iconClose}
          />
          <div className={styles.rowNameAndProfile}>
            <div className={styles.inputTextName}>
                <label>Nome do usuário</label>
                <input
                onChange={(e) => setNameUser(e.target.value)}
                value={nameUser}
                name='nameUser'
                />
            </div>
            <div className={styles.contentRadioGroup}>
              <span className={styles.labelSelectProfile}>Perfil do Usuário</span>
              <RadioGroup value={valueProfile} onChange={setValueProfile}>
                <Radio inline value="regional">Regional</Radio>
                <Radio inline value="painel">ADM</Radio>
              </RadioGroup>
            </div>
            {/* <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="controlled-radio-buttons-group"
                value={valueProfile}
                onChange={handleChangeProfile}
              >
                <FormControlLabel value="regional" control={<Radio />} label="Regional" />
                <FormControlLabel value="r" control={<Radio />} label="ADM" />
              </RadioGroup>
            </FormControl> */}
          </div>
          <div className={styles.inputText}>
              <label>E-mail</label>
              <input
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              name='email'
              />
          </div>
            {valueProfile === 'regional' &&
            <SelectRegion 
            left={left}
            setLeft={setLeft}
            right={right}
            setRight={setRight}
            />}
            <div className={styles.boxBTNSubmit}>
                <span
                onClick={() => handleSubmitEditUser()}
                >Editar usuário</span>
            </div>
            {loading &&
            <div className={styles.boxContentLoading}>
              <div className={styles.progressSpinner}>
                <CircularProgress 
                color='inherit'
                />
              </div>
            </div>}
        </div>
      </Dialog>
    )
}